import React, { useEffect, useState } from "react";
import { Badge, Dialog, DialogTitle, DialogContent, Typography, Box, DialogActions, Button } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import HomeIcon from "@mui/icons-material/Home";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonIcon from "@mui/icons-material/Person";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { t } from "i18next";
import axios from "axios";
import "../css/mobileScreens.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FCM_TOKEN, getAuthMobile, getGustAuthMobile, getLocalStorageMenuItem, sendNotificationFirebaseRes, setLocalStorageMenuItem, setMobileBackColor, setMobileCardBorderColor, setMobileCardColor, setMobileTextColor, setMobileTextField_BK_FONT_Border_StyleColor } from "../utility";
import { LoginOutlined, LoginRounded, ShoppingCart } from "@mui/icons-material";
import Pusher from "pusher-js";
import addNotification from "react-push-notification";
import noImageAvailable from "../images/No_Image_Available.jpg";
import LoginComponent from "./mobile screen/mobileComponents/loginComponent";
import Toast from './../common/toast';
import { useQuery } from "react-query";
import { motion, AnimatePresence } from "framer-motion";

const BottomNavBar = ({ qrName, qr, saveCartState, refetchBaskeFunc }) => {

    const [toastSettings, setToastSettings] = useState({
        open: false,
        message: "",
        success: false,
    });

    const handleOpenToast = (message, state) => {
        setToastSettings({
            open: true,
            success: state,
            message: message
        });
    };

    const handleCloseToast = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setToastSettings({ open: false, message: "", success: false });
    };

    const [showInfoDailog, setShowInfoDailog] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [params] = useSearchParams();
    const [detailsData] = useState(getLocalStorageMenuItem("tree_data").details || []);
    const [allTreeData, setAllTreeData] = useState(getLocalStorageMenuItem("tree_data") || []);
    const navigate = useNavigate();
    const location = useLocation();

    const handleOpenDialog = () => setIsDialogOpen(true);
    const handleCloseDialog = () => setIsDialogOpen(false);
    // const [basketItems, setBasketItems] = useState([]);

    const [loginDialogOpen, setLoginDialogOpen] = useState(false);


    const shouldMobileHideNavbar = /\/[^/]+\/(menus|items)$/.test(location.pathname);

    const [cartAnimate, setCartAnimate] = useState(false);




    useEffect(() => {
        const pusher = new Pusher("ae14bac927c237af424c", {
            cluster: "mt1",
            auth: getGustAuthMobile(),
        });
        const channel = pusher.subscribe(
            `customer_notifications.${getLocalStorageMenuItem("gustToken")}`
        );
        channel.bind("App\\Events\\NotificationRespond", (data) => {
            addNotification({
                title: data.title,
                message: data.message,
                duration: 8000,
                icon: detailsData?.logo || noImageAvailable,
                native: true,
                onClick: () => console.log("notification received"),
            });

        });

        return () => {
            pusher.unsubscribe("customer_notifications");
            pusher.disconnect();
        };
    }, []);


    const {
        data: basketItems,
        isLoading: basketIsLoading,
        refetch: refetchBasket
    } = useQuery(
        ["basket-items-count", getLocalStorageMenuItem("lang")],
        async () => {
            const response = await axios.get(
                `${process.env.REACT_APP_API}/basket-items-count?menu_code=${qr}&token=${getLocalStorageMenuItem("gustToken")}`,
                {
                    headers: {
                        localization: getLocalStorageMenuItem("lang"),
                    },
                }
            );

            return response;
        }
    );

    useEffect(() => {
        if (basketItems?.data?.data?.items?.length) {
            // Trigger animation when cart item count changes
            setCartAnimate(true);
            const timer = setTimeout(() => setCartAnimate(false), 600);
            return () => clearTimeout(timer);
        }
    }, [basketItems?.data?.data?.items?.length]);

    if (shouldMobileHideNavbar) {
        return null;
    }


    const handleNavigation = (path) => navigate(path);

    const handleSendNotification = async (title, body) => {
        try {
            const sendNotificationRes = await axios.post(
                `${process.env.REACT_APP_API}/general-notification`,
                {
                    venue_id: detailsData?.venue_id,
                    title: title || "",
                    message: body || "",
                    table: params.get("t") || "",
                }
            );


            const sendNotificationFirebase = await sendNotificationFirebaseRes(detailsData, title || "", body || "", "notifications");

            if (sendNotificationRes?.data?.success && sendNotificationFirebase?.data?.success) {

                setShowInfoDailog(true);

            } else {

                handleOpenToast(
                    <div className="alignByLang">
                        {t("Error while sending the notification.")}
                    </div>
                    , false);
            }
        } catch (error) {

            handleOpenToast(
                <div className="alignByLang">
                    {t("Error while sending the notification.") + " " + error.message}
                </div>
                , false);
        }
    };


    const handleFeedBack = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        navigate(
            `/${qrName}/${qr}/feedback?section=${params.get("section")}&t=${params.get("t")}&lang=${params.get("lang")}`
        );
    };
    const handleFavorites = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        navigate(
            `/${qrName}/${qr}/favorites?section=${params.get("section")}&t=${params.get("t")}&lang=${params.get("lang")}`
        );
    };

    const handleClickCart = async () => {
        if (refetchBaskeFunc) {
            await refetchBaskeFunc()
        }
        if (basketItems?.data?.data?.items?.filter(item => item.is_order_option === 0)?.length > 0) {

            navigate(
                `/${qrName}/${qr}/cart?section=${params.get(
                    "section"
                )}&t=${params.get("t")}&lang=${params.get("lang")}`
            )
        } else {
            handleOpenToast(
                <div className="alignByLang">
                    {t("Your Cart is empty")}
                </div>
                , true);
        }

    };


    const handleHome = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        navigate(`/${qrName}/${qr}/sections?section=0&lang=${params.get("lang")}&t=${params.get("t")}`, {
            replace: true
        });
    };

    const handleProfile = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        navigate(`/${qrName}/${qr}/profile?lang=${getLocalStorageMenuItem("lang")}&t=${params.get("t")}`, {
            replace: true
        });
    };

    const handleLogin = async () => {

    };

    const handleLogout = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        await setLocalStorageMenuItem("mobileLoginToken", "");
        navigate(`/${qrName}/${qr}/menus?lang=${getLocalStorageMenuItem("lang")}&t=${params.get("t")}`, {
            replace: true
        });
    };

    const handleOrders = () => {
        navigate(
            `/${qrName}/${qr}/orders?section=${params.get("section")}&t=${params.get("t")}&lang=${params.get("lang")}`
            , {
                replace: true
            });
    };



    const handleOpenLoginDialog = (is_from_order) => {
        setLoginDialogOpen(true);
    };

    const handleCloseLoginDialog = () => {
        setLoginDialogOpen(false);
    };

    const handleVerificationSuccess = (token) => {
        if (token) {
            setLocalStorageMenuItem("mobileLoginToken", token || "");

        }
    };

    const dialogStyles = {
        backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
        color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
        borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
    };



    return (
        !allTreeData?.details?.order_ability && !allTreeData?.details?.whatsapp ? true :
            <div>
                {/* <ToastContainer /> */}
                <div className="bottom-nav alignByLang" style={{ backgroundColor: setMobileCardColor() }}>
                    <button className="nav-item" onClick={() => handleHome()}>
                        <HomeIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                        <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Home")}</span>
                    </button>

                    <button className="nav-item" onClick={() => handleFavorites()}>
                        <FavoriteIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                        <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Favorites")}</span>
                    </button>



                    {JSON.parse(params.get("t")) && (
                        <button className="nav-item" onClick={handleOpenDialog}>
                            <HelpOutlineIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                            <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Helper")}</span>
                        </button>
                    )}



                    <button disabled={!allTreeData?.details?.is_available} className="nav-item" onClick={() => handleClickCart()}>
                        <div>
                            <Badge
                                badgeContent={
                                    <motion.span
                                        style={{
                                            backgroundColor: "#D92D20",
                                            color: "#f5f10eff",
                                            padding: "3px",
                                            borderRadius: 20,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            minWidth: "20px",
                                            minHeight: "20px",
                                        }}
                                        key={basketItems?.data?.data?.items?.filter(item => item.is_order_option === 0)?.length || 0}
                                        initial={{ scale: 0, rotate: -180 }}
                                        animate={{ scale: 1, rotate: 0 }}
                                        transition={{
                                            type: "spring",
                                            stiffness: 300,
                                            damping: 15,
                                            duration: 0.5
                                        }}
                                    >
                                        {basketItems?.data?.data?.items?.filter(item => item.is_order_option === 0)?.length || 0}
                                    </motion.span>
                                }
                                sx={{ color: setMobileCardColor() }}
                            >
                                <motion.div
                                    style={{ position: "relative", display: "inline-block" }}
                                    whileTap={{ scale: 0.95 }}
                                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                                >
                                    <motion.div
                                        animate={cartAnimate ? {
                                            scale: [1, 1.2, 1],
                                            rotate: [0, -5, 5, 0],
                                            y: [0, -4, 0]
                                        } : {}}
                                        transition={{
                                            duration: 0.6,
                                            ease: "easeInOut",
                                            times: [0, 0.3, 0.6, 1]
                                        }}
                                        style={{
                                            display: "inline-block",
                                            filter: cartAnimate ?
                                                "drop-shadow(0 0 8px rgba(255, 215, 0, 0.6))" :
                                                "none",
                                        }}
                                    >
                                        <ShoppingCart
                                            style={{
                                                color: setMobileTextColor(),
                                                filter: cartAnimate ? "brightness(1.2)" : "brightness(1)"
                                            }}
                                            fontSize="medium"
                                        />
                                    </motion.div>

                                    {/* Bigger pulse effect */}
                                    <AnimatePresence>
                                        {cartAnimate && (
                                            <motion.div
                                                style={{
                                                    position: "absolute",
                                                    top: "-15px",  // Increased offset
                                                    left: "-15px", // Increased offset
                                                    right: "-15px", // Increased offset
                                                    bottom: "-15px", // Increased offset
                                                    borderRadius: "50%",
                                                    border: `2px solid ${setMobileTextColor()}`,
                                                    opacity: 0.6,
                                                }}
                                                initial={{ scale: 1, opacity: 0.8 }}
                                                animate={{ scale: 2.5, opacity: 0 }}  // Increased scale from 1.5 to 2.5
                                                exit={{ opacity: 0 }}
                                                transition={{ duration: 0.8, ease: "easeOut" }}
                                            />
                                        )}
                                    </AnimatePresence>
                                </motion.div>
                            </Badge>
                        </div>
                        <motion.span
                            style={{ color: setMobileTextColor() }}
                            className="sub-font"
                            animate={cartAnimate ? { color: ["#inherit", "#FFD700", "#inherit"] } : {}}
                            transition={{ duration: 0.6 }}
                        >
                            {t("Cart")}
                        </motion.span>
                    </button>
                    {getLocalStorageMenuItem("mobileLoginToken") ? (
                        <>
                            <button className="nav-item" onClick={() => handleProfile()}>
                                <PersonIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                                <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("My Profile")}</span>
                            </button>
                            {/* <button className="nav-item" onClick={() => handleLogout()}>
                                {getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fr" ?
                                    (
                                        <ExitToAppIcon style={{ color: setMobileTextColor(), transform: "rotate(180deg)" }} fontSize="medium" />
                                    )
                                    :
                                    (
                                        <ExitToAppIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                                    )
                                }

                                <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Logout")}</span>
                            </button> */}
                        </>

                    ) : (
                        <button className="nav-item" onClick={() => handleOpenLoginDialog()}>
                            <LoginRounded style={{ color: setMobileTextColor() }} fontSize="medium" />
                            <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Login")}</span>
                        </button>
                    )}


                </div>
                <Dialog sx={{
                    "& .MuiPaper-root": {
                        backgroundColor: setMobileCardColor(),
                        width: "80%"
                    },
                }} open={isDialogOpen} onClose={handleCloseDialog}>
                    <DialogTitle sx={{ color: setMobileTextColor() }}>{t("Helper")}</DialogTitle>
                    <DialogContent>
                        <div className="notification-buttons">
                            <Badge
                                sx={{ backgroundColor: setMobileTextColor(), color: setMobileBackColor() }}
                                onClick={() =>
                                    handleSendNotification(
                                        "call waiter",
                                        "please call waiter for this table"
                                    )
                                }
                                className="badge-style"
                            >
                                {t("Call Waiter")}
                            </Badge>

                            {detailsData?.notification_buttons_settings?.notification_1_active && (
                                <Badge
                                    sx={{ backgroundColor: setMobileTextColor(), color: setMobileBackColor() }}
                                    onClick={() =>
                                        handleSendNotification(
                                            detailsData.notification_buttons_settings.notification_1_title,
                                            detailsData.notification_buttons_settings.notification_1_body
                                        )
                                    }
                                    className="badge-style"
                                >
                                    {t(detailsData.notification_buttons_settings.notification_1_button) || ""}
                                </Badge>
                            )}

                            {detailsData?.notification_buttons_settings?.notification_2_active && (
                                <Badge
                                    onClick={() =>
                                        handleSendNotification(
                                            detailsData.notification_buttons_settings.notification_2_title,
                                            detailsData.notification_buttons_settings.notification_2_body
                                        )
                                    }
                                    className="badge-style"
                                >
                                    {t(detailsData.notification_buttons_settings.notification_2_button) || ""}
                                </Badge>
                            )}
                        </div>
                        {/* <Button onClick={handleCloseDialog}>{t("Close")}</Button> */}
                    </DialogContent>
                </Dialog>

                <LoginComponent
                    open={loginDialogOpen}
                    handleCloseDialog={handleCloseLoginDialog}
                    tableQr={qr}
                    tableName={qrName}
                    onVerificationSuccess={handleVerificationSuccess}
                    is_from={2}
                />

                <Toast
                    open={toastSettings.open}
                    message={toastSettings.message}
                    resetToast={handleCloseToast}
                    success={toastSettings.success}
                />



                <Dialog
                    open={showInfoDailog}
                    onClose={() => setShowInfoDailog(false)}
                    maxWidth="sm"
                    PaperProps={{
                        style: {
                            borderRadius: 15,
                            padding: "20px",
                            backgroundColor: dialogStyles.backgroundColor,
                            border: `1px solid ${setMobileCardBorderColor()}'}`,
                        },
                    }}
                >
                    <DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
                        <Typography variant="h6" fontWeight="bold" color={setMobileTextColor()}>
                            {t("Hi")}
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Box sx={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                            <Typography variant="body1" textAlign="center" color={dialogStyles.color}>
                                {t("Your order sent and it will be with you as sson as possible, Thank you.")}
                            </Typography>
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: "center" }}>
                        <Button
                            onClick={() => setShowInfoDailog(false)}
                            sx={{
                                backgroundColor: setMobileCardBorderColor(),
                                color: '#fff',
                                padding: "8px 16px",
                                borderRadius: "30px",
                                "&:hover": {
                                    backgroundColor: setMobileCardBorderColor(),
                                },
                            }}
                        >
                            {t("ok")}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>




    );
};

export default BottomNavBar;
